import { render, staticRenderFns } from "./answer_question.vue?vue&type=template&id=4c4c8615&scoped=true"
import script from "./answer_question.vue?vue&type=script&lang=js"
export * from "./answer_question.vue?vue&type=script&lang=js"
import style0 from "./answer_question.vue?vue&type=style&index=0&id=4c4c8615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c8615",
  null
  
)

export default component.exports